var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottom3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 0C8.57733 0 10.6667 2.08934 10.6667 4.66667V8H11.3333L11.4017 8.00326C11.7378 8.03748 12 8.32155 12 8.66667V11.3333L11.9967 11.4017C11.9648 11.7153 11.7153 11.9648 11.4017 11.9967L11.3333 12H0.666667C0.321549 12 0.0374763 11.7378 0.00325521 11.4017L0 11.3333V8.66667C4.29507e-08 8.29848 0.298477 8 0.666667 8H1.33333V4.66667C1.33333 2.08934 3.42267 0 6 0ZM1.33333 10.6667H10.6667V9.33333H1.33333V10.6667ZM6 1.33333C4.15905 1.33333 2.66667 2.82572 2.66667 4.66667V8H5.33333V4.66667C5.33333 4.29848 5.63181 4 6 4C6.36819 4 6.66667 4.29848 6.66667 4.66667V8H9.33333V4.66667C9.33333 2.82572 7.84095 1.33333 6 1.33333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottom3);
export default __webpack_public_path__ + "static/media/bottom3.a23ad026d6dc22f86bd4383af97c3ab0.svg";
export { ForwardRef as ReactComponent };